import type { BusinessType } from "@/lib/businessConfig";
import type { ComponentType } from "react";

// Broker sections
import { BrokerHero, BrokerFeaturedListings, BrokerWhyChooseUs } from "./BrokerSections";
// Builder sections
import { BuilderHero, BuilderOngoingProjects, BuilderAmenities, BuilderConstructionProgress } from "./BuilderSections";
// Eco sections
import { EcoHero, EcoGreenFeatures, EcoCommunityLiving, EcoSustainabilityStats } from "./EcoSections";
// Luxury sections
import { LuxuryHero, LuxuryExclusiveGallery, LuxuryConciergeServices, LuxuryLifestyle } from "./LuxurySections";
// Urban sections
import { UrbanHero, UrbanAvailableSpaces, UrbanAmenitiesGrid, UrbanCommunityEvents, UrbanPricing } from "./UrbanSections";
// Shared sections
import { SharedTestimonials, SharedCTA, SharedPartners } from "./SharedSections";

type SectionRegistry = Record<string, Record<string, ComponentType>>;

const SECTION_REGISTRY: SectionRegistry = {
  broker: {
    hero: BrokerHero,
    partners: SharedPartners,
    "featured-listings": BrokerFeaturedListings,
    "why-choose-us": BrokerWhyChooseUs,
    testimonials: SharedTestimonials,
    cta: SharedCTA,
  },
  builder: {
    hero: BuilderHero,
    "ongoing-projects": BuilderOngoingProjects,
    "builder-amenities": BuilderAmenities,
    "construction-progress": BuilderConstructionProgress,
    testimonials: SharedTestimonials,
    cta: SharedCTA,
  },
  eco: {
    hero: EcoHero,
    "green-features": EcoGreenFeatures,
    "community-living": EcoCommunityLiving,
    "sustainability-stats": EcoSustainabilityStats,
    testimonials: SharedTestimonials,
    cta: SharedCTA,
  },
  luxury: {
    hero: LuxuryHero,
    "exclusive-gallery": LuxuryExclusiveGallery,
    "concierge-services": LuxuryConciergeServices,
    "luxury-lifestyle": LuxuryLifestyle,
    testimonials: SharedTestimonials,
    cta: SharedCTA,
  },
  urban: {
    hero: UrbanHero,
    "available-spaces": UrbanAvailableSpaces,
    "amenities-grid": UrbanAmenitiesGrid,
    "community-events": UrbanCommunityEvents,
    pricing: UrbanPricing,
    cta: SharedCTA,
  },
};

export function getSectionComponent(businessType: BusinessType, sectionId: string): ComponentType | null {
  return SECTION_REGISTRY[businessType]?.[sectionId] || null;
}

export function getSectionComponents(businessType: BusinessType): Record<string, ComponentType> {
  return SECTION_REGISTRY[businessType] || {};
}
